var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whitespace-nowrap text-sm",attrs:{"role":"button"},on:{"click":_vm.showEditRoleDialog}},[_vm._v("Edit")])
}
var staticRenderFns = []

export { render, staticRenderFns }